import React from "react";
import {
  GridComponent,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Inject,
  Resize,
  Edit,
  CommandColumn,
  ForeignKey,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
} from "@syncfusion/ej2-react-grids";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { auth, cicassService } from "../../../_services";
import { getValue, Internationalization } from "@syncfusion/ej2-base";
import { DateTimePickerComponent } from "@syncfusion/ej2-react-calendars";
import { withTranslation } from "react-i18next";
import TokenContext from "components/TokenContext";
import { DateTime } from "luxon";
import { Box, TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import itLocale from "date-fns/locale/it";

import { SwitchComponent } from "@syncfusion/ej2-react-buttons";
import DownloadIcon from '@mui/icons-material/Download';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PersonIcon from '@mui/icons-material/Person';
import { IconButton, Tooltip } from "@mui/material"; // AGGIUNTO Tooltip
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'; // Icona freccia sinistra
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'; // Icona freccia destra
import AttendanceCardView from "./components/AttendanceCardView";
import AttendanceReportGrid from "./components/AttendanceReportGrid";

import { config } from "_helpers";


const editSettings = {
  allowEditing: true,
  allowAdding: true,
  allowDeleting: true,
  mode: "Dialog",
  dialog: { enableResize: true },
  showDeleteConfirmDialog: true,
};
const editUserSetting = {
  allowEditing: false,
  allowAdding: false,
  allowDeleting: false,
  mode: "Dialog",
  dialog: { enableResize: true },
  showDeleteConfirmDialog: true,
};
const filterSettings = { type: "CheckBox" }; // Menu, Excel

const toolbarUserOptions = [
  // "Search",
  "ExcelExport",
  "Print",
  {
    text: "Refresh",
    tooltipText: "Refresh",
    prefixIcon: "e-MT_reload",
    id: "forceRefresh",
  },
];
const commands = [
  {
    type: "Edit",
    buttonOption: { iconCss: " e-icons e-edit", cssClass: "e-flat" },
  },
  {
    type: "Delete",
    buttonOption: { iconCss: "e-icons e-delete", cssClass: "e-flat" },
  },
  {
    type: "Save",
    buttonOption: { iconCss: "e-icons e-update", cssClass: "e-flat" },
  },
  {
    type: "Cancel",
    buttonOption: { iconCss: "e-icons e-cancel-icon", cssClass: "e-flat" },
  },
];

const apiUrl = "attendance";
const apiUrlUserCombo = "authlogin";
const apiEndpointGetAttendanceType = "ana_attendance_type";
const apiEndpointAttendanceMonthly = "attendance/month";

const currentYear = new Date().getFullYear();
const maxDate = new Date(currentYear + 1 + "-12-31");
const minDate = new Date(2022, 0, 1);

class Attendance extends React.Component {
  _isMounted = false;
  grid = null;
  static contextType = TokenContext;
  constructor(props) {
    super(props);
    this.position = { X: "Right", Y: "Bottom" };
    this.state = {
      loggedUserId: 0,
      currentSearchTerm: "",
      attendaceData: [],
      attendaceDataCopy: [],
      visibleOnGrid: false,
      didMountCompleted: false,
      isCicass: false,
      editEnabled: false,
      userData: [],
      toastInfo: {
        title: "",
        content: "Succesfully",
        cssClass: "e-toast-success",
        icon: "e-success toast-icons",
      },
      isAttendanceReportGridVisible: false,
      datePickerValue: new Date(),
      selectedYear: "",
      isCalculationDone: false,
      datePickerViews: ["year", "month"],
      isExpiredFilterSelected: false,
      isInvalidFilterSelected: false,
      isUncompletedFilterSelected: false,
      totalTime: "",
      autoClosedOptions: []
    };
    this.validationUser = {
      required: [this.notBlank.bind(this), "Questo campo è obbligatorio"],
    };

    this.validationAttendanceCause = {
      required: [
        this.notNullOrUndefined.bind(this),
        "Questo campo è obbligatorio",
      ],
    };
    this.validationFrom = {
      required: true,
      min: [
        this.lsTo.bind(this),
        '"Data Da" deve essere inferiore di "Data A"',
      ],
    };
    this.validationTo = {
      required: true,
      min: [
        this.gtFrom.bind(this),
        '"Data A" deve essere maggiore o uguale a "Data Da"',
      ],
    };
    this.actionComplete = this.actionComplete.bind(this);
    this.actionBegin = this.actionBegin.bind(this);
    this.onMonthChange = this.onMonthChange.bind(this);
    this.refreshGrid = this.refreshGrid.bind(this);
    this.filterAttendance = this.filterAttendance.bind(this);
    this.isValidDate = this.isValidDate.bind(this);
    this.handlePrevMonth = this.handlePrevMonth.bind(this);
    this.handleNextMonth = this.handleNextMonth.bind(this);
    this.excelQueryCellInfo = this.excelQueryCellInfo.bind(this);
  }

  toolbarOptions = [
    // "Search",
    "Add",
    "ExcelExport",
    "Print",
    {
      text: "Refresh",
      tooltipText: "Refresh",
      prefixIcon: "e-MT_reload",
      id: "forceRefresh",
    },
    {
      text: "- " + this.props.t("filterExpiredAttendance"),
      tooltipText: this.props.t("filterExpiredAttendance"),
      id: "filterExpired",
      align: "center",
    },
    {
      text: "- " + this.props.t("filterInvalidAttendance"),
      tooltipText: this.props.t("filterInvalidAttendance"),
      id: "filterInvalid",
      align: "center",
    },
    {
      text: "- " + this.props.t("filterUncompletedAttendance"),
      tooltipText: this.props.t("filterUncompletedAttendance"),
      id: "filterUncompleted",
      align: "center",
    },
  ];

  notBlank(args) {
    return args.value !== "1"; // blank user
  }

  notNullOrUndefined(args) {
    return !!args.value !== false;
  }

  lsTo(args) {
    let valueRead = getValue("value", args); // from
    let fromDate =
      valueRead.substring(6, 10) +
      "-" +
      valueRead.substring(3, 5) +
      "-" +
      valueRead.substring(0, 2) +
      valueRead.substring(11, 16);
    let valueReadTo = document.getElementById("toDt").value;
    let toDate =
      valueReadTo.substring(6, 10) +
      "-" +
      valueReadTo.substring(3, 5) +
      "-" +
      valueReadTo.substring(0, 2) +
      valueReadTo.substring(11, 16);
    return toDate == "--" ? fromDate : fromDate <= toDate;
  }

  gtFrom(args) {
    let valueRead = getValue("value", args); // to
    // console.log(valueRead);
    let toDate =
      valueRead.substring(6, 10) +
      "-" +
      valueRead.substring(3, 5) +
      "-" +
      valueRead.substring(0, 2) +
      valueRead.substring(11, 16);
    let valueReadFrom = document.getElementById("fromDt").value;
    let fromDate =
      valueReadFrom.substring(6, 10) +
      "-" +
      valueReadFrom.substring(3, 5) +
      "-" +
      valueReadFrom.substring(0, 2) +
      valueReadFrom.substring(11, 16);
    return fromDate == "--" ? toDate : toDate >= fromDate;
  }

  async componentDidMount() {
    
    this._isMounted = true;
    const autoClosedOptions = [
      { id: 0, label: this.props.t("manual") },
      { id: 1, label: this.props.t("system") }
    ];
    const myrole = auth.getUserRole();
    const token = this.context;
    const loggedUserId = auth.getUserId(token.jwt);
    let { data: userData } = await cicassService.getAll(apiUrlUserCombo);
    let { data: iAmManagerOfAttendance } = await cicassService.getAll(apiUrl + "/ismanager");
    let editEnabled =
      myrole === "Admin" ||
      myrole === "SuperUser" ||
      (myrole === "Manager" && iAmManagerOfAttendance);

    let isCicass = myrole === "SuperUser";
    if (this._isMounted) {
      
      const attendanceCauseOptions = await cicassService.getAll(apiEndpointGetAttendanceType);

      window.addEventListener("resize", this.handleResize);
      this.setState({
        didMountCompleted: true,
        autoClosedOptions,
        userData,
        isCicass,
        editEnabled,
        isMobile: window.innerWidth < config.mobileSizeCheck,
        attendanceCauseOptions: attendanceCauseOptions.data,loggedUserId
      }, () => {
              const now = new Date();
              const initialYear = now.getFullYear();
              const initialMonth = now.getMonth() + 1;
              
              this.refreshGrid(initialYear, initialMonth, true);
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("resize", this.handleResize);
  }

  handleSearchChange = (searchTerm) => {
    this.setState({ currentSearchTerm: searchTerm });
  };
  handleResize = () => {
   
    // 1. Calcola il nuovo stato di isMobile
  const isMobileNow = window.innerWidth < config.mobileSizeCheck;
  const freshData = [...this.state.attendaceDataCopy];
  const year = this.state.datePickerValue.getFullYear();
  const month = this.state.datePickerValue.getMonth() + 1;
 //console.log (isMobileNow, freshData , year , month);
  // 3. Aggiorna lo stato e usa il CALLBACK per il calcolo
  this.setState({ 
    isMobile: isMobileNow,
    attendaceData: freshData 
  }, () => {
    this.refreshGrid(year, month, true);
    this.calculateAndSetTotal(freshData, isMobileNow);
  });
  }

  calculateAndSetTotal(data, isMobile) {
  const { loggedUserId } = this.state;
  let totalSeconds = 0;

  // Applica la logica: se mobile solo io, se desktop tutti (o quelli filtrati)
  const dataToSum = isMobile 
    ? data.filter(item => item.anaUserId === loggedUserId)
    : data;

  dataToSum.forEach((item) => {
    const toDt = item.toDt instanceof Date ? item.toDt : new Date(item.toDt);
    const fromDt = item.fromDt instanceof Date ? item.fromDt : new Date(item.fromDt);

    if (toDt && fromDt && !isNaN(toDt.getTime())) {
      totalSeconds += (toDt.getTime() - fromDt.getTime()) / 1000;
    }
  });

  let totalStr = "---";
  if (totalSeconds > 0) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    totalStr = `${hours} ${this.props.t("h")} ${minutes} ${this.props.t("m")} ${seconds} ${this.props.t("s")}`;
  }

  this.setState({ totalTime: totalStr });
}

  onMonthChange(newValue) {
    this.refreshGrid(newValue.getFullYear(), newValue.getMonth() + 1, true);
    if (this.gridInstance && this.gridInstance.clearFiltering) {
      this.gridInstance.clearFiltering();
    }
  }

  filterAttendance(type) {
    const attendanceDataInit = this.state.attendaceDataCopy;
    const filteredAttendance = attendanceDataInit.filter((item) => {
      const toDt = DateTime.fromJSDate(item.toDt);
      const fromDt = DateTime.fromJSDate(item.fromDt);
      const { hours, minutes } = toDt
        .diff(fromDt, ["hours", "minutes"])
        .toObject();

      if (type === "invalid") {
        return minutes <= 5 && hours === 0;
      }
      if (type === "expired") {
        return hours >= 12;
      }
      if (type === "uncompleted") {
        return item.toDt === null || !this.isValidDate(item.toDt);
      }
      return null;
    });

    let totalTime = 0;
    filteredAttendance.map((item) => {
      const toDt = Math.floor(new Date(item.toDt).getTime() / 1000)
      const fromDt = Math.floor(new Date(item.fromDt).getTime() / 1000)
      if (!toDt.invalid)
        totalTime = totalTime + (toDt - fromDt);
    })
    const totalTimeAsDate = new Date(totalTime * 1000)
    if (totalTime)
      totalTime = Math.floor(totalTime / 60 / 60) + " " + this.props.t("h") + " " + totalTimeAsDate.getMinutes() + " " + this.props.t("m") + " " + totalTimeAsDate.getSeconds() + " " + this.props.t("s");
    else
      totalTime = "---"

    this.setState({ attendaceData: filteredAttendance, totalTime: totalTime });
  }

  isValidDate(date) {
    return date instanceof Date && !isNaN(date);
  }

  handleSearchTermChange = (newSearchTerm) => {
    this.setState({ currentSearchTerm: newSearchTerm });
  };
handlePrevMonth() {
  const { datePickerValue, isAttendanceReportGridVisible } = this.state;
  // Se il report annuale è visibile, sottraiamo un anno, altrimenti un mese
  const offset = isAttendanceReportGridVisible ? 12 : 1;
  const newDate = new Date(datePickerValue.getFullYear(), datePickerValue.getMonth() - offset, 1);
  
  if (newDate >= minDate) {
    this.setState({ datePickerValue: newDate }, () => {
      // Aggiorniamo la griglia solo se NON siamo nel report annuale
      if (!isAttendanceReportGridVisible) {
        this.refreshGrid(newDate.getFullYear(), newDate.getMonth() + 1, true);
        if (this.gridInstance) {
          this.gridInstance.clearFiltering();
        }
      }
      // Se siamo nel report annuale, il re-render passerà il nuovo anno a AttendanceReportGrid
    });
  }
}

handleNextMonth() {
  const { datePickerValue, isAttendanceReportGridVisible } = this.state;
  const offset = isAttendanceReportGridVisible ? 12 : 1;
  const newDate = new Date(datePickerValue.getFullYear(), datePickerValue.getMonth() + offset, 1);
  
  if (newDate <= maxDate) {
    this.setState({ datePickerValue: newDate }, () => {
      if (!isAttendanceReportGridVisible ) {
        this.refreshGrid(newDate.getFullYear(), newDate.getMonth() + 1, true);
        if (this.gridInstance) {
          this.gridInstance.clearFiltering();
        }
      }
    });
  }
}
  toolbarClick(args) {
    const gridId = this.gridInstance.htmlattributes.id;
    switch (args.item.properties.id) {
      case `${gridId}_excelexport`:
        this.gridInstance.excelExport();
        break;
      case "filterExpired":
        this.filterAttendance("expired");
        this.setState({ isExpiredFilterSelected: true });
        break;
      case "filterInvalid":
        this.filterAttendance("invalid");
        this.setState({ isInvalidFilterSelected: true });
        break;
      case "filterUncompleted":
        this.filterAttendance("uncompleted");
        this.setState({ isUncompletedFilterSelected: true });
        break;
      default:
        break;
    }
    if (args.item.id === "forceRefresh") {
      this.refreshGrid(null, null, true);
      this.gridInstance.clearFiltering();
    }
  }

  async getYearDetails() {
    try {
      const { currentSearchTerm } = this.state;
      const isFiltered = window.innerWidth < config.mobileSizeCheck ? true : false;
      const year = this.state.datePickerValue.getFullYear();
      let fileName = "Presenze_" + year;
      if (!isFiltered)
        {
          await cicassService.downloadCsvFile(apiUrl + `/report/download/${year}`,fileName);
        }
      else
        {   const term = (currentSearchTerm && currentSearchTerm.trim() !== "") 
              ? currentSearchTerm.trim() 
              : "#";
            let url = apiUrl + `/report/downloadFiltered/${year}?searchTerm=${encodeURIComponent(term)}`;
            await cicassService.downloadCsvFile(url, fileName);
        }
    }
    catch (error) {
    this.toastObj.show({
      title: "Errore",
      content: "Impossibile scaricare il report",
      cssClass: "e-toast-danger"
    });
    }
  }
  async refreshGrid(newYear, newMonth, isToolbarRefreshClicked) {
    try {
      //this.gridInstance.clearFiltering();
      
      if (this.state.isExpiredFilterSelected && !isToolbarRefreshClicked) {
        this.filterAttendance("expired");
        return;
      }
      if (this.state.isInvalidFilterSelected && !isToolbarRefreshClicked) {
        this.filterAttendance("invalid");
        return;
      }
      if (this.state.isUncompletedFilterSelected && !isToolbarRefreshClicked) {
        this.filterAttendance("uncompleted");
        return;
      }
      const year = newYear ?? this.state.datePickerValue.getFullYear();
      const month = newMonth ?? this.state.datePickerValue.getMonth() + 1;
      const { data } = await cicassService.getAll(apiEndpointAttendanceMonthly + `/${year}/${month}`);
      const dataForTotal = window.innerWidth < config.mobileSizeCheck 
        ? data.filter(item => item.anaUserId === this.state.loggedUserId)
        : data;
      let totalTime = 0;
      
      const attendaceData = dataForTotal.map((item) => {
        const toDt = DateTime.fromISO(item.toDt);
        const fromDt = DateTime.fromISO(item.fromDt);

        let builtTimeSpent;
        if (!toDt.invalid) {
          const timeDiff = toDt.ts - fromDt.ts;
          builtTimeSpent = new Date(timeDiff).toLocaleTimeString([], { timeZone: "utc" })
          totalTime = totalTime + timeDiff / 1000;
        }

        return {
          ...item,
          fromDt: fromDt.toJSDate(),
          toDt: toDt.toJSDate(),
          timeSpent: builtTimeSpent,
          // toDateString: toDt.toISO(),
        };
      });

      const totalTimeAsDate = new Date(totalTime * 1000)
      if (totalTime)
        totalTime = Math.floor(totalTime / 60 / 60) + " " + this.props.t("h") + " " + totalTimeAsDate.getMinutes() + " " + this.props.t("m") + " " + totalTimeAsDate.getSeconds() + " " + this.props.t("s");
      else
        totalTime = "---"
      this.setState({ attendaceData, attendaceDataCopy: attendaceData, totalTime: totalTime });
    } catch (error) {
      console.error("Error in refreshGrid:", error);
    }
  }

  actionBegin(state) {
    if (state.requestType === "beginEdit" || state.requestType === "add") {
      if (state.requestType === "add") {
        state.id = -1;
        state.data.anaAgencyId = auth.getAgencyId();
        const token = this.context;
        state.data.anaUserId = auth.getUserId(token.jwt);
      }
      this.setState({ visibleOnGrid: true });
    }
  }
  
  autoClosedTemplate = (props) => {
    const isAuto = props.autoClosed === 1;
    const config = {
      label: isAuto ? this.props.t("system") : this.props.t("manual"),
      icon: isAuto ? 
      <SmartToyIcon style={{ fontSize: '0.9rem' }} /> : 
      <PersonIcon style={{ fontSize: '0.9rem' }} />,
    color: isAuto ? '#0288d1' : '#616161',
    bgColor: isAuto ? 'rgba(2, 136, 209, 0.12)' : 'rgba(0, 0, 0, 0.05)',
    border: isAuto ? '1px solid #0288d1' : '1px solid #bdbdbd'
  };

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center', // Centra icona e testo
      gap: '6px',               // Spazio fisso tra icona e testo
      padding: '4px 0',         // Padding verticale (orizzontale gestito dalla width)
      borderRadius: '6px',
      fontSize: '0.7rem',
      fontWeight: '800',
      textTransform: 'uppercase',
      width: '105px',           // LARGHEZZA FISSA: uniforma tutti i badge
      backgroundColor: config.bgColor,
      color: config.color,
      border: config.border,
    }}>
      {config.icon}
      <span>{config.label}</span>
    </div>
    );
  };

  timeSpentTemplate(args) {
    let styles = {};
    // 🛑 AGGIUNGI QUESTO CONTROLLO: Se 'toDt' è nullo o non è una data valida
      if (!args.toDt || args.toDt.toString() === "Invalid Date") {
          styles.color = "red"; // Puoi scegliere il colore, ad esempio rosso per attirare l'attenzione
          return <p style={styles}>{"Uscita Mancante"}</p>;
      }
    const toDt = DateTime.fromJSDate(args.toDt);
    const fromDt = DateTime.fromJSDate(args.fromDt);
    const diff = toDt.diff(fromDt).shiftTo("hours", "minutes", "seconds").toObject();
    const totalHours = Math.floor(diff.hours);
    const minutes = Math.floor(diff.minutes);
    const seconds = Math.floor(diff.seconds);
    const timeString = `${String(totalHours).padStart(2,"0")}:${String(minutes).padStart(2,"0")}:${String(seconds).padStart(2,"0")}`;

    if (totalHours < 1 && minutes <= 5) styles.color = "orange";
    else if (totalHours >= 12) styles.color = "red";

    return <p style={styles}>{timeString}</p>;
  }


  getUsernameById(id) {
    return this.state.userData.find((user) => user.id === id).name;
  }

  formatDateToISO(dateTime) {
    const format = "yyyy-MM-dd'T'HH:mm:ss";
    return dateTime.toFormat(format);
  }

  actionComplete(state) {
    if (state.action === "filter" || state.action === "clear-filter") {
      const filteredAttendance = this.gridInstance.getFilteredRecords();
      let totalTime = 0;
      filteredAttendance.map((item) => {
        const toDt = Math.floor(new Date(item.toDt).getTime() / 1000)
        const fromDt = Math.floor(new Date(item.fromDt).getTime() / 1000)
        if (!toDt.invalid && !isNaN(toDt))
          totalTime = totalTime + (toDt - fromDt);
      })
      const totalTimeAsDate = new Date(totalTime * 1000)
      if (totalTime)
        totalTime = Math.floor(totalTime / 60 / 60) + " " + this.props.t("h") + " " + totalTimeAsDate.getMinutes() + " " + this.props.t("m") + " " + totalTimeAsDate.getSeconds() + " " + this.props.t("s");
      else
        totalTime = "---"
      this.setState({ totalTime: totalTime });
    }
    if (state.requestType === "add" || state.requestType === "beginEdit") {
      state.dialog.enableResize = true;
      //state.dialog.element.style.maxHeight = 900;
      state.dialog.width = 600;
      state.dialog.height = 600;
      if (state.requestType === "beginEdit") {
        const name = this.getUsernameById(state.rowData.anaUserId);
        state.dialog.header = `Dettagli di ${name}`;
      }
    }
    if (state.action === "add") {
      state.data.id = -1;
      state.data.createdAt = new Date();
      delete state.data.anaAgencyId;
      delete state.data.userRoleList;
      const data = {
        ...state.data,
        fromDt: this.formatDateToISO(DateTime.fromJSDate(state.data.fromDt)),
        toDt: this.formatDateToISO(DateTime.fromJSDate(state.data.toDt)),
      };
      cicassService
        .saveOp(apiUrl, data)
        .then(() => {
          this.setToastInfo("Success", this.props.t("toastSuccess"));
        })
        .catch((err) => {
          console.error("Error on add:", err);
          this.setToastInfo("Error", "I: " + err.message);
        })
        .finally(() => {
          this.refreshGrid();
        });
    }
    if (state.action === "edit") {
      delete state.data.anaAgencyId;
      delete state.data.userRoleList;
      let data = {
        ...state.data,
        fromDt: this.formatDateToISO(DateTime.fromJSDate(state.data.fromDt)),
        toDt: this.formatDateToISO(DateTime.fromJSDate(state.data.toDt)),
      };

      cicassService
        .saveOp(apiUrl, data)
        .then(() => {
          this.setToastInfo("Success", this.props.t("toastSuccess"));
        })
        .catch((err) => {
          console.error("Error on edit:", err);
          this.setToastInfo("Error", "U: " + err.message);
        })
        .finally(() => {
          this.refreshGrid();
        });
    }
    if (state.requestType === "delete") {
      cicassService
        .deleteOp(apiUrl, state.data[0].id)
        .then(() => {
          this.setToastInfo("Success", this.props.t("toastSuccess"));
        })
        .catch((err) => {
          console.error("Error on delete:", err);
          this.setToastInfo("Error", "D:" + err.message);
        })
        .finally(() => {
          this.refreshGrid();
        });
    }

    this.setState({ visibleOnGrid: false });
  }

  setToastInfo(title, msg) {
    let toastInfo = {};
    switch (title) {
      case "Warning":
        toastInfo.title = "Warning";
        toastInfo.content = msg;
        toastInfo.cssClass = "e-toast-warning";
        toastInfo.icon = "e-warning toast-icons";
        break;
      case "Success":
        toastInfo.title = "Success";
        toastInfo.content = msg;
        toastInfo.cssClass = "e-toast-success";
        toastInfo.icon = "e-success toast-icons";
        break;
      case "Error":
        toastInfo.title = "Error";
        toastInfo.content = msg;
        toastInfo.cssClass = "e-toast-danger";
        toastInfo.icon = "e-error toast-icons";
        break;
      case "Information":
        toastInfo.title = "Information";
        toastInfo.content = msg;
        toastInfo.cssClass = "e-toast-info";
        toastInfo.icon = "e-info toast-icons";
        break;
      default:
        break;
    }
    this.setState({ toastInfo });
    this.toastObj.show();
  }

  exitDateTemplate(args) {
    try {
      const parsedDate = DateTime.fromJSDate(args.toDt).toISO() ?? "";
      return parsedDate;
    } catch (err) {
      return "";
    }
  }

  editTemplateFrom(args) {
    return (
      <DateTimePickerComponent
        value={getValue("fromDt", args)}
        id="fromDt"
        placeholder="From"
        floatLabelType="Always"
        format={"dd/MM/yyyy HH:mm"}
        locale="it"
      />
    );
  }

  editTemplateTo(args) {
    return (
      <DateTimePickerComponent
        value={getValue("toDt", args)}
        id="toDt"
        placeholder="To"
        floatLabelType="Always"
        format={"dd/MM/yyyy HH:mm"}
        locale="it"
      />
    );
  }

  excelQueryCellInfo(args) {
    if (args.column.field === "toDt" || args.column.field === "fromDt") {
      const intl = new Internationalization();
      const dFormatter = intl.getDateFormat({ format: "dd/MM/yyyy HH:mm:ss" });
      const formattedDate = dFormatter(args.value);
      args.value = formattedDate;
    }
    if (args.column.field === 'autoClosed') {
      // Trasformiamo lo 0/1 nel testo tradotto
     /* args.value = args.value === 1 
        ? this.props.t("system") 
        : this.props.t("manual");*/
         const option = this.state.autoClosedOptions.find(opt => opt.id === args.value);
    args.value = option ? option.label : args.value;
    }
  }

  toggleYearlyAttendanceReport() {
    const { isAttendanceReportGridVisible, datePickerValue } = this.state;
    const nextVisibleState = !isAttendanceReportGridVisible;

    this.setState({
      isAttendanceReportGridVisible: nextVisibleState,
      datePickerViews: nextVisibleState ? ["year"] : ["year", "month"],
    }, () => {
      // Se stiamo tornando alla visualizzazione MENSILE
      if (!nextVisibleState) {
        // Sincronizziamo i dati della griglia con la data attualmente 
        // selezionata nel calendario (che potrebbe essere cambiata nell'anno)
        this.refreshGrid(
          datePickerValue.getFullYear(), 
          datePickerValue.getMonth() + 1, 
          true
        );
        
        if (this.gridInstance) {
          this.gridInstance.clearFiltering();
        }
      }
    });
  }

  render() {
    const {
      attendaceData,
      didMountCompleted,
      userData,
      isCicass,
      toastInfo,
      editEnabled,
      attendanceCauseOptions,
      isAttendanceReportGridVisible,
      totalTime,loggedUserId
    } = this.state;
    const { t } = this.props;
    const isMobile = window.innerWidth < config.mobileSizeCheck;
    return (
      <main>
        <div style={{ margin: "1.2rem 0 .3rem 1.2rem" }}>
          <Box
            sx={{
              display: "flex",
              mr: 2,
              mt: 2,
              alignItems: "center",
            }}
          >
            <Typography variant="h6" component="h2">
              {t("titleAttendanceJs")}
            </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end',  alignItems: "center",p: '5px' }}>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                locale={itLocale}
                sx={{
                  ml: "auto",
                }}
              >
                <Tooltip title={isAttendanceReportGridVisible ? t("Anno Precedente") : t("Mese Precedente")}>
                    <IconButton 
                        onClick={this.handlePrevMonth} 
                        // Disabilita se la data selezionata è inferiore o uguale alla minDate (Gennaio 2022)
                        disabled={this.state.datePickerValue.getFullYear() <= minDate.getFullYear() && this.state.datePickerValue.getMonth() <= minDate.getMonth()}
                        size="medium"
                        sx={{ 
                            my: 0.5,
                            mr: 1,
                            bgcolor: 'primary.main',
                            color: 'white',
                            '&:hover': {
                                bgcolor: 'primary.dark',
                            },
                            '&.Mui-disabled': {
                                bgcolor: 'rgba(0, 0, 0, 0.12)',
                                color: 'rgba(255, 255, 255, 0.4)',
                            }
                        }}
                    >
                        <ArrowBackIosNewIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
                <DatePicker
                  views={this.state.datePickerViews}
                  minDate={minDate}
                  maxDate={maxDate}
                  value={this.state.datePickerValue}
                  onChange={(newVal) =>
                    this.setState({ datePickerValue: newVal })
                  }
                  onMonthChange={this.onMonthChange}
                  renderInput={(params) => (
                                  <TextField {...params} 
                                    helperText={null} 
                                    size="small"
                                    sx={{
                                      width: 'fit-content',  // 👈 Si adatta al contenuto
                                      minWidth: '120px',     // 👈 Larghezza minima
                                      '& .MuiInputBase-input': {
                                        fontSize: '0.9rem',  // 👈 Carattere più piccolo
                                        py: 1,             // 👈 Padding verticale minimo
                                        px: 1,               // 👈 Padding orizzontale minimo
                                        with: "auto"
                                      },
                                      '& .MuiInputBase-root': {
                                        height: '36px',      // 👈 Altezza fissa compatta
                                      }
                                    }}/>
                                )}
                  sx={{ width: 180 }}
                />
                {/* ➡️ PULSANTE MESE SUCCESSIVO */}
                <Tooltip title={isAttendanceReportGridVisible ? t("Anno Successivo") : t("Mese Successivo")}>
                    <IconButton 
                        onClick={this.handleNextMonth} 
                        // Disabilita se la data selezionata è maggiore o uguale alla maxDate
                        disabled={this.state.datePickerValue.getFullYear() >= maxDate.getFullYear() && this.state.datePickerValue.getMonth() >= maxDate.getMonth()}
                        size="medium"
                        sx={{ 
                            my: 0.5,
                            ml: 1,
                            bgcolor: 'primary.main',
                            color: 'white',
                            '&:hover': {
                                bgcolor: 'primary.dark',
                            },
                            '&.Mui-disabled': {
                                bgcolor: 'rgba(0, 0, 0, 0.12)',
                                color: 'rgba(255, 255, 255, 0.4)',
                            }
                        }}
                    >
                        <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
              </LocalizationProvider>
            
          </Box>
          <Box
            component="aside"
            sx={{
              display: "flex",
              // In mobile va in colonna, da tablet (sm) in su resta in riga
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              justifyContent: "space-between",
              gap: { xs: 2, sm: 1 },
              mb: 2
            }}
          >
            {/* Gruppo Switch + Download */}
            <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <Typography component="h3" color="black" sx={{ fontWeight: 500 }}>
                {t("showAttendanceReport")}
              </Typography>
              <SwitchComponent
                checked={this.state.isAttendanceReportGridVisible}
                // Mantenuta la tua logica originale
                change={() => this.toggleYearlyAttendanceReport()}
              />
              {isAttendanceReportGridVisible && (
                <IconButton
                  color="primary"
                  title={t("allYear")}
                  // Mantenuta la tua logica originale
                  onClick={() => {
                    this.getYearDetails();
                  }}
                  sx={{ ml: { xs: 0, sm: 1 } }}
                >
                  <DownloadIcon />
                </IconButton>
              )}
            </Box>

            {/* Gruppo Totale */}
            {(!isAttendanceReportGridVisible && totalTime) ? (
              <Box 
                sx={{ 
                  // In mobile lo spinge a destra per bilanciare lo stack
                  alignSelf: { xs: "flex-end", sm: "center" },
                  bgcolor: { xs: "#f5f5f5", sm: "transparent" },
                  px: { xs: 1.5, sm: 0 },
                  py: { xs: 0.5, sm: 0 },
                  borderRadius: "8px"
                }}
              >
                <Typography component="h3" color="black">
                  <span style={{ fontWeight: 300, color: "#666", marginRight: "4px" }}>
                    {t("totalTimeSpent")}:
                  </span>
                  <b style={{ fontWeight: "bold", color: "#666", marginRight: "20px" }}>{totalTime}</b>
                </Typography>
              </Box>
            ) : null}
          </Box>

        </div>
        <Box sx={{ p: 2, flex: '1 1 auto' }}>
          {didMountCompleted && !isAttendanceReportGridVisible && (
            <>
              {/* 📱 MOBILE: Card View */}
              {isMobile && (
                <AttendanceCardView 
                  dataKey={`${this.state.datePickerValue.getFullYear()}-${this.state.datePickerValue.getMonth()}`}
                  data={attendaceData.filter(item => item.anaUserId === loggedUserId)} 
                  t={t} attendanceCauseOptions={attendanceCauseOptions} userNames={userData}/>
              )}
              
              {/* 🖥️ DESKTOP: Syncfusion Grid */}
              {!isMobile && (
                <GridComponent
                  id="attendanceGrid"
                  ref={(grid) => (this.gridInstance = grid)}
                  dataSource={attendaceData}
                  allowResizing={true}
                  toolbar={editEnabled ? this.toolbarOptions : toolbarUserOptions}
                  editSettings={editEnabled ? editSettings : editUserSetting}
                  allowFiltering={true}
                  filterSettings={filterSettings}
                  allowPaging={true}
                  pageSettings={{ pageSize: 10, pageCount: 5 }}
                  allowExcelExport={true}
                  actionComplete={this.actionComplete}
                  actionBegin={this.actionBegin}
                  toolbarClick={this.toolbarClick.bind(this)}
                  excelQueryCellInfo={this.excelQueryCellInfo}
                  locale="it"
                  allowSorting={true}
                >
                  <ColumnsDirective>
                    <ColumnDirective
                      field="id"
                      headerText={t("id")}
                      textAlign="Right"
                      isPrimaryKey={true}
                      defaultValue="-1"
                      allowEditing={false}
                      visible={isCicass}
                      width="100"
                    />
                    <ColumnDirective
                      field="anaUserId"
                      headerText={t("anaUserId")}
                      foreignKeyValue="name"
                      foreignKeyField="id"
                      dataSource={userData}
                      visible={editEnabled}
                      width="130"
                      validationRules={this.validationUser}
                    />
                    <ColumnDirective
                      field="anaAttendanceTypeId"
                      headerText={t("anaAttendanceTypeId")}
                      dataSource={attendanceCauseOptions}
                      foreignKeyValue="name"
                      foreignKeyField="id"
                      width="150"
                      validationRules={this.validationAttendanceCause}
                    />
                    <ColumnDirective
                      field="attendanceNote"
                      headerText={t("attendanceNote")}
                      width="150"
                    />
                    <ColumnDirective
                      field="fromDt"
                      headerText={t("fromDt")}
                      type="datetime"
                      format="dd/MM/yyyy HH:mm:ss"
                      allowEditing={editEnabled}
                      editTemplate={this.editTemplateFrom.bind(this)}
                      validationRules={this.validationFrom}
                      width="140"
                    />
                    <ColumnDirective
                      field="toDt"
                      // field="toDateString"
                      allowFiltering={false}
                      headerText={t("toDt")}
                      type="datetime"
                      format="dd/MM/yyyy HH:mm:ss"
                      allowEditing={editEnabled}
                      editTemplate={this.editTemplateTo.bind(this)}
                      // template={this.exitDateTemplate}
                      validationRules={this.validationTo}
                      width="140"
                    />
                    <ColumnDirective
                      field="timeSpent"
                      headerText={t("timeSpent") +" (hh:mm:ss)"}
                      allowEditing={false}
                      allowFiltering={false}
                      template={this.timeSpentTemplate}
                      width="140"
                      visible={true}
                    />
                    <ColumnDirective 
                      field="autoClosed" 
                      headerText={t("autoClosed")} 
                      width="130" 
                      template={this.autoClosedTemplate}
                      allowFiltering={true}
                      foreignKeyValue="label"
                      foreignKeyField="id"
                      dataSource={this.state.autoClosedOptions}
                    />
                    <ColumnDirective
                      field="anaAgencyId"
                      headerText={t("anaAgencyId")}
                      allowEditing={false}
                      visible={isCicass}
                      width="150"
                    />
                    <ColumnDirective
                      field="createdAt"
                      headerText={t("createdAt")}
                      visible={isCicass}
                      allowEditing={false}
                      type="dateTime"
                      format="dd/MM/yyyy HH:mm:ss"
                    />
                    <ColumnDirective
                      field="updatedAt"
                      headerText={t("updatedAt")}
                      visible={isCicass}
                      allowEditing={false}
                      type="dateTime"
                      format="dd/MM/yyyy HH:mm:ss"
                    />
                    {editEnabled && (
                      <ColumnDirective
                        headerText={t("operationOnGrid")}
                        width="100"
                        textAlign="left"
                        commands={commands}
                      />
                    )}
                  </ColumnsDirective>
                  <Inject
                    services={[
                      Resize,
                      Filter,
                      Page,
                      Toolbar,
                      Edit,
                      ForeignKey,
                      CommandColumn,
                      ExcelExport,
                      Sort,
                    ]}
                  />
                </GridComponent>
              )}
            </>
          )}
          {this.state.isAttendanceReportGridVisible && (
            <AttendanceReportGrid
              isVisible={this.state.isAttendanceReportGridVisible}
              handleHide={() =>
                this.setState({ isAttendanceReportGridVisible: false })
              }
              selectedYear={this.state.datePickerValue.getFullYear()}
              loggedUserId={loggedUserId}
              searchEnabled = {editEnabled}
              onSearchChange={this.handleSearchTermChange}
            />
          )}
        </Box>
        <ToastComponent
          ref={(toast) => {
            this.toastObj = toast;
          }}
          id="toast_default"
          position={this.position}
          title={toastInfo.title}
          content={toastInfo.content}
          cssClass={toastInfo.cssClass}
          icon={toastInfo.icon}
        />
      </main>
    );
  }
}
export default withTranslation()(Attendance);
